export const getAngleInDegFromString = (angle: string): number => {
  if (!angle) return 0;
  return Math.floor((parseInt(angle, 10) || 0) % 360);
};
